var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.loading )?_c('v-app',[(!_vm.$route.meta.login && _vm.$auth.user)?_c('header-bar'):_vm._e(),_c('v-main',[_c('router-view')],1),_c('session-expired-snackbar'),_c('snackbar')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }